<template>
  <div id="app" >
    <v-app>
      <div v-if="isSupportSession" class="support-session-banner">
        <v-icon small class="mr-2">mdi-account-eye</v-icon>
        <strong>Support als {{ mySelf.displayname || mySelf.email }}</strong>
        <span class="ml-2">durch {{ mySelf.support_session.actor.displayname || mySelf.support_session.actor.email }}</span>
        <v-btn x-small outlined class="ml-3" @click="endSupportSession">Beenden</v-btn>
      </div>
      <v-main :style="{background: $vuetify.theme.themes[theme].background_primary}">
        <router-view></router-view>
      </v-main>
      <v-dialog v-model="supportSessionEnded" persistent max-width="480">
        <v-card>
          <v-card-title>Support-Sitzung beendet</v-card-title>
          <v-card-text>Dieses Fenster kann jetzt geschlossen werden.</v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="pushPromptVisible" persistent max-width="520">
        <v-card>
          <v-card-title class="text-h5">
            <v-icon color="primary" class="mr-3">mdi-bell-ring-outline</v-icon>
            Benachrichtigungen aktivieren?
          </v-card-title>
          <v-card-text>
            <p class="body-1 mb-3">{{ pushPromptText }}</p>
            <v-alert v-if="pushPromptError" type="error" outlined dense class="mb-3">
              {{ pushPromptError }}
            </v-alert>
            <v-checkbox
              v-model="pushPromptDontAsk"
              hide-details
              label="Nicht mehr nachfragen"
            ></v-checkbox>
          </v-card-text>
          <v-card-actions class="px-6 pb-5">
            <v-spacer></v-spacer>
            <v-btn text :disabled="pushPromptLoading" @click="dismissPushPrompt">Später</v-btn>
            <v-btn
              color="primary"
              :loading="pushPromptLoading"
              @click="activatePushFromPrompt"
            >Aktivieren</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <PwaInstallPrompt
        v-if="!isSupportSession"
        :authenticated="!!mySelf"
        app-name="OBS Web"
        storage-key="obs:pwa-install"
      />
    </v-app>
    <!-- <div v-if="debugMode" class="version caption">
      <v-btn color="#A22222" @click="doLogout()">
        <v-btn x-small color="#2222A2" @click="doReload()">X</v-btn>{{version}}</v-btn>
    </div>
    <div v-else class="version caption" @click="debugMode = true;">
      {{version}}
    </div> -->
    
    <!-- <div v-if="debugMode" class="bottom-menu-left">
      <v-btn class="mb-1 mr-3" @click="changeTheme">Switch Theme</v-btn>
    </div> -->
  </div>
  
</template>

<script>
import { mapState, mapActions } from "vuex";
import _ from "lodash";
import packageJson from "../package.json";
import api from "./api";
import { enablePush, mobilePwaNeedsInstallation as mobileInstallRequired, pushStatus, syncPushSubscription } from "./utils/pushNotifications";
import PwaInstallPrompt from "./components/PwaInstallPrompt.vue";

export default {
  name: "App",
  components: { PwaInstallPrompt },
  data() {
    return {
      //debugMode: false,
      version: "V1." + packageJson.version.substring(2,packageJson.version.length), //"V1.7.33",
      //version: "V1.7.46",
      drawer: false,
      items: [],
      //mini: true,
      right: null,
      supportSessionEnded: false,
      pushPromptVisible: false,
      pushPromptDontAsk: false,
      pushPromptLoading: false,
      pushPromptError: "",
      pushState: "unsupported",
      pushCheckInProgress: false,
      pushCheckedUserId: null,
      // theme1: undefined,
    };
  },

  mounted() {
    // this.logout();
    // this.theme1 = JSON.stringify(this.$vuetify.theme.themes);
    console.log("App mounted");
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", this.handleServiceWorkerMessage);
    }
    this.$root.$on("pwa-install-completed", this.handlePwaInstalled);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    this.lockPortraitOrientation();
    if (this.mySelf && !this.isSupportSession) {
      this.checkPushOnStart();
    }
  },
  computed: {
    ...mapState({
      status: ({ user }) => user.status,
      loading: (state) => state.loading,
      statusMySelf: ({ auth }) => auth.statusMySelf,
      mySelf: ({ auth }) => auth.mySelf,
      Drawer: (state) => state.drawer,
    }),
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    isSupportSession() {
      return !!this.mySelf?.support_session?.active;
    },
    pushPromptText() {
      if (this.pushState === "denied") {
        return "Benachrichtigungen sind im Browser blockiert. Erlauben Sie sie bitte zuerst in den Website-Einstellungen und wählen Sie danach Aktivieren.";
      }
      if (this.pushState === "unavailable") {
        return "Die Push-Funktion wird gerade vorbereitet. Mit Aktivieren können Sie die Einrichtung erneut prüfen.";
      }
      return "Erlauben Sie OBS, wichtige Nachrichten auch dann anzuzeigen, wenn die App gerade nicht geöffnet ist.";
    }
  },
  watch: {
    mySelf(value) {
      if (!value) {
        this.pushPromptVisible = false;
        this.pushPromptDontAsk = false;
        this.pushPromptError = "";
        this.pushCheckedUserId = null;
        //console.log("No mySelf!");
        this.IntervalOff();
        this.$router.push({ name: "login" });
        return;
      }   
      if (!this.isSupportSession) {
        this.checkPushOnStart();
      }
      
      if (this.mySelf.obs_settings?.theme == "dark") {
        this.$vuetify.theme.isDark = true;
      } else {
        this.$vuetify.theme.isDark = false;
      }

      this.items = [];
      try {
        //console.log(this.mySelf.roles);
        if (this.mySelf.roles.includes("user")) {
          this.items.push({
            title: "Home",
            icon: "mdi-home",
            color: "blue darken-2",
            path: "/home",
          });
          this.items.push({
            title: "Issue",
            icon: "mdi-archive",
            color: "green",
            path: "/issue",
          });
          this.items.push({
            title: "Report",
            icon: "mdi-chart-box-outline",
            color: "orange",
            path: "/report",
          });
        } else if (this.mySelf.roles.includes("admin")) {
          console.log("admin detected");
          this.$router.options.routes.forEach((route) => {
            if (!_.isUndefined(route.icon)) {
              this.items.push({
                title: route.name,
                icon: route.icon,
                color: route.color,
                path: route.path,
              });
            }
          });
        }
      } catch (error) {
        void error;
      }
    },
  },
  destroyed() {
    this.IntervalOff();
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.removeEventListener("message", this.handleServiceWorkerMessage);
    }
    this.$root.$off("pwa-install-completed", this.handlePwaInstalled);
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  },
  methods: {
    ...mapActions("auth", ["getMySelf", "logout"]),

    async lockPortraitOrientation() {
      if (!window.screen?.orientation?.lock) return;
      try {
        await window.screen.orientation.lock("portrait-primary");
      } catch (error) {
        // The web manifest and native wrapper still enforce portrait mode.
      }
    },
    handleVisibilityChange() {
      if (!document.hidden) this.lockPortraitOrientation();
    },

    // changeTheme () {
    //   this.$vuetify.theme.isDark = !this.$vuetify.theme.isDark
    // },

    pushRoute(item) {
      let item_path = item.path;
      item_path = item_path.slice(1, item.path.length);
      //this.mini = true
      //this.drawer = false
      this.$router.push(item_path);
    },
    actualRoute(path) {
      let getRoute = _.find(this.items, { path });
      if (_.isUndefined(getRoute)) {
        getRoute = {
          color: "",
          icon: "",
          name: "",
        };
      }
      return getRoute;
    },
    // doLogout() {
      
    //   try {
    //     let authData = {};
    //     authData = JSON.parse(localStorage.getItem("authData"));
    //     authData.autoLogin = false;
    //     localStorage.setItem("authData", JSON.stringify(authData));
    //   } catch (err) {
    //     console.log(err);
    //   }
      
    //   this.logout();
    // },
    doReload() {
      window.location.reload(true);
    },
    pushPromptStorageKey() {
      return `obs:push-prompt-dismissed:${this.mySelf?._id || "anonymous"}`;
    },
    hasDismissedPushPrompt() {
      try {
        return localStorage.getItem(this.pushPromptStorageKey()) === "true";
      } catch (error) {
        return false;
      }
    },
    savePushPromptPreference() {
      try {
        if (this.pushPromptDontAsk) {
          localStorage.setItem(this.pushPromptStorageKey(), "true");
        } else {
          localStorage.removeItem(this.pushPromptStorageKey());
        }
      } catch (error) {
        // The preference is optional when browser storage is unavailable.
      }
    },
    async checkPushOnStart() {
      const userId = this.mySelf?._id;
      if (this.pushCheckInProgress || !userId || this.isSupportSession || this.pushCheckedUserId === userId) return;
      if (this.mobilePwaNeedsInstallation()) {
        this.pushPromptVisible = false;
        return;
      }
      this.pushCheckedUserId = userId;
      this.pushCheckInProgress = true;
      try {
        this.pushState = await pushStatus();
        if (this.pushState === "enabled") {
          this.pushPromptVisible = false;
          this.pushPromptDontAsk = false;
          this.savePushPromptPreference();
          await syncPushSubscription();
          return;
        }
        if (this.pushState !== "unsupported" && !this.hasDismissedPushPrompt()) {
          this.pushPromptError = "";
          this.pushPromptDontAsk = false;
          this.pushPromptVisible = true;
        }
      } catch (error) {
        // Push remains optional; the notification center can still be used.
      } finally {
        this.pushCheckInProgress = false;
      }
    },
    mobilePwaNeedsInstallation() {
      return mobileInstallRequired();
    },
    handlePwaInstalled() {
      this.pushCheckedUserId = null;
      this.checkPushOnStart();
    },
    dismissPushPrompt() {
      this.savePushPromptPreference();
      this.pushPromptVisible = false;
      this.pushPromptError = "";
    },
    async activatePushFromPrompt() {
      this.pushPromptLoading = true;
      this.pushPromptError = "";
      this.savePushPromptPreference();
      try {
        await enablePush();
        this.pushState = "enabled";
        this.pushPromptVisible = false;
      } catch (error) {
        try {
          this.pushState = await pushStatus();
        } catch {
          this.pushState = "available";
        }
        this.pushPromptError = error?.message || "Benachrichtigungen konnten nicht aktiviert werden.";
      } finally {
        this.pushPromptLoading = false;
      }
    },
    handleServiceWorkerMessage(event) {
      if (event.data?.type !== "OPEN_NOTIFICATIONS") return;
      this.$router.push({ name: "notifications", query: { conversation: event.data.conversationId, message: event.data.messageId } }).catch(() => {});
    },
    async endSupportSession() {
      try {
        await api.endSupportSession();
      } catch (err) {
        // The support token may already have expired; still close locally.
      }
      sessionStorage.removeItem("SupportAuthorization");
      this.IntervalOff();
      window.close();
      window.setTimeout(() => {
        this.supportSessionEnded = true;
      }, 100);
    },
    IntervalOff() {
      try {
        if (!_.isUndefined(this.$store.authInterval)) {
          clearInterval(this.$store.authInterval);
          this.$store.authInterval = undefined;
        }
      } catch (e) {
        //
      }
    },
  },
};
</script>

<style lang='scss'>
.card--flex-toolbar {
  margin-top: 0px;
  margin-bottom: 0px;
}

.body {
  overscroll-behavior-y: contain !important;
}

.html {
  overscroll-behavior-y: contain !important;
}
body {
  overscroll-behavior-y: contain !important;
}
html {
  overscroll-behavior-y: contain !important;
}
#app {
  overflow-x: hidden;
  overflow-y: hidden;
}
.support-session-banner {
  position: fixed;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 6px;
  color: #1f1f1f;
  background: #ffca28;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
}
.version {
  position: absolute;
  bottom: 0%;
  left: 40%;
}
</style>
